class StickyAtcBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleEvent = (e) => {
      if (e.detail.sticking) {
        this._stick();
      } else {
        this._unstick();
      }
    };

    document.addEventListener("atc-bar-sticking", this.handleEvent);
  }

  disconnectedCallback() {
    document.removeEventListener("atc-bar-sticking", this.handleEvent);
  }

  _stick() {
    this.removeEventListener("transitionend", this.onEnd);
    this.bar.style.display = null;

    window.requestAnimationFrame(() => {
      this.bar.style.transform = "translateY(0)";
    });
  }

  _unstick() {
    this.removeEventListener("transitionend", this.onEnd);

    this.onEnd = () => {
      this.removeEventListener("transitionend", this.onEnd);

      this.bar.style.display = "none";
    };

    this.addEventListener("transitionend", this.onEnd);

    this.bar.style.transform = null;
  }

  get bar() {
    return this.querySelector("[data-sticky-atc-bar]");
  }
}

if (!customElements.get("sticky-atc-bar")) {
  customElements.define("sticky-atc-bar", StickyAtcBar);
}
